import React, { useEffect, useMemo, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Make sure Bootstrap is installed
import { MdOutlineAdd, MdOutlineDelete, MdOutlineEdit } from 'react-icons/md';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { useNavigate } from 'react-router';
import { t } from 'i18next';
import i18n from 'src/i18n';
import "./surveys.css"
import { fetchDataApi, uploadExcelForRiskProfile } from 'src/services/question';
import { Modal } from 'reactstrap';
import { toast } from 'react-toastify';
import { deleteSurveyApi } from 'src/services/question';
import { useTranslation } from "react-i18next";

import { FcApproval, FcExport } from 'react-icons/fc';
import { TfiImport } from 'react-icons/tfi';
import { CiExport } from 'react-icons/ci';
import * as XLSX from 'xlsx';
import { submitQuestionsAndAnswers } from 'src/services/userServicer';
import LoadingScreen from 'src/Loading/LoadingScreen';


const SurvyQuestionTable = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [surveys, setSurveys] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [selectedSurveyId, setSelectedSurveyId] = useState<string | null>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
      setIsModalOpen(!isModalOpen);
    };

    const confirmDelete = (id: string) => {
      setSelectedSurveyId(id);
      toggleModal();
    };
  
    const handleDelete = async () => {
      if (selectedSurveyId !== null) {
        try {
          await deleteSurveyApi(selectedSurveyId);
          setSurveys((prevSurveys:any) => prevSurveys.filter((survey:any) => survey.id !== selectedSurveyId));
          toggleModal();
          toast.success(t("surveys.Survey deleted successfully"));
        } catch (error: any) {
          toast.error(t("surveys.Failed to delete survey"));
        }
      }
    };



    const fetchSurveys = async () => {
      setLoading(true);
      try {
        const data = await fetchDataApi(`publicSurvey?perPage=${pageSize}&pageNo=${page}&query=${searchTerm}`);
        if(data.success){
          setSurveys(data.data);
          setTotalPages(data.totalPages); // Ensure the API provides total pages
          setLoading(false);
          setError(false);
        }
       
      } catch (error: any) {
        setLoading(false);
        setError(true);
        setErrorMsg(error.message || "An error occurred while fetching data.");
      }
    }

    useEffect(() => {
        fetchSurveys();
    }, [page,pageSize,searchTerm]);

    

    
  const handleDownloadTemplate = () => {
    const rcsaData = [
      [
        "Survey Name", 
        "Category", 
        "Reference", 
        "Question", 
        "Bank Response", 
        "Question Type",
        "Options",
        "Quarter", 
        "Year", 
        "answerdby"
      ],
      // Example row
      [
        "Risk Profile Q1 2024", 
        "Category 1", 
        "Reference 1", 
        "Question 1", 
        "Least",
        "single_choice",
        "Least,Minimal,Moderate,Significant,Most",
        "Q1", 
        "2024",
        "User Name"
      ],
      // Add more rows as needed
    ];
  
    // Create a new workbook and add sheets
    const workbook = XLSX.utils.book_new();
    const rcsaSheet = XLSX.utils.aoa_to_sheet(rcsaData);
  
    // Append sheets to the workbook
    XLSX.utils.book_append_sheet(workbook, rcsaSheet, 'RCSA');
  
    // Write the workbook to a file
    XLSX.writeFile(workbook, "Inherent Risk Profile.xlsx");
  };
  
  const handleImportExcel = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
        try {
            const response = await uploadExcelForRiskProfile(file);
            toast.success(response.message || "Excel file imported successfully");
  
            
        } catch (error) {
            toast.error("Error importing Excel file");
        }
    }
  };
  
   
    
  

  return (
    <div className="root">
           {loading && (
        <div className="loading-overlay">
          <div ></div>
     <LoadingScreen/>
        </div>
      )}
    <div className="d-flex justify-content-between align-items-center mb-2">

       <h5 className="mb-lg">{t("surveys.Surveys")}</h5>

   <button className="btn-create" 
        onClick={() => navigate('/createsurvey')}><MdOutlineAdd size={20} />
        {t("surveys.Create Survey")}</button>
</div>
   
    <div className="d-flex justify-content-between align-items-center mb-2">
      <h5 className="mb-lg">Question and Answer Upload</h5>

    
      <div>
                  <input
                      type="file"
                      accept=".xlsx, .xls"
                      onChange={(e) => {
                        const file = e.target.files?.[0];
                        if (file) {
                          handleImportExcel(e);
                        } else {
                          toast.error(t("error.no_file_selected"));
                        }
                      }}
                      style={{ display: 'none'}}
                      id="import-excel"
                    />
                    <b><label htmlFor="import-excel" className="btn-upload mr-2" style={{width:'250px',textAlign:'center'}}>
                    <b><TfiImport className="mr-2  font-weight-bold" size={16}/> {t("Standards_Page.import_excel")}</b>
                    </label></b>
          
                    <button className="btndoweload mr-2" onClick={handleDownloadTemplate} style={{width:'250px'}}>
                    <b><CiExport className="mr-2 font-weight-bold" size={16}/>  {t("Standards_Page.download_excel_template")}</b>
                    </button>
      </div>
    </div>
   
   <div className="container_info" style={{padding:'40px 20px',backgroundColor:'var(--widget-bg)'}}>
      <div className="d-flex justify-content-between my-2">
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder={t("surveys.search_placeholder") || ''}
          className="search-input"
        />
    
      </div>
      <table className="styled-table">
          <thead className="table-dark">
            <tr>
              <th style={{ width: '30%' }}>{t("surveys.title")}</th>
              <th style={{ width: '20%' }}>{t("surveys.description")}</th>
              <th style={{ width: '30%' }}>{t("surveys.users")}</th>
              <th>{t("surveys.actions")}</th>
            </tr>
          </thead>
          <tbody>
            {surveys.map((item:any) => (
              <tr key={item.id}>
                <td>{i18n.language === 'ar' ? item.name_ar : item.name_en}</td>
                <td>{i18n.language === 'ar' ? item.description_ar : item.description_en}</td>
                <td>{item.publicSurveyUsers.map((user: any) => user.user.name).join(", ")}</td>
              <td>
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
    <button
      className="action-button-success"
    
      onClick={() => navigate(`/assessmentsurvey/${item.id}`)}
    >
      <FcApproval size={20} />
    </button>

    <button
      className="action-button-info"
    
      onClick={() => navigate(`/exportsurvey/${item.id}`)}
    >
      <FcExport size={20} />
    </button>

    <button
      className="action-button"
   
      onClick={() => navigate(`/updatesurvey/${item.id}`)}
    >
      <MdOutlineEdit size={20} />
    </button>

    <button
      className="action-button-without-border"
    
      onClick={() => confirmDelete(item.id)}
    >
      <MdOutlineDelete size={20} />
    </button>
  </div>
</td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>

       {/* Pagination */}
       <div className="pagination-controls mt-5">
                <button
                  className="btn btn-warning btn-sm text-white"
                  onClick={() => setPage(1)}
                  disabled={page ===1}
                >
                  {"<<"}
                </button>{" "}
                <button
                  className="btn btn-warning btn-sm text-white"
                  onClick={() => setPage((prev) => Math.max(prev - 1,1))}
                  disabled={page === 1}
                >
                  {"<"}
                </button>{" "}
                <button
                  className="btn btn-warning btn-sm text-white"
                  onClick={() =>
                    setPage((prev) =>
                      Math.min(
                        prev + 1,
                        totalPages 
                      )
                    )
                  }
                  disabled={
                    page >= totalPages 
                  }
                >
                  {">"}
                </button>{" "}
                <button
                  className="btn btn-warning btn-sm text-white"
                  onClick={() =>
                    setPage(
                      totalPages 
                    )
                  }
                  disabled={
                    page >= totalPages 
                  }
                >
                  {">>"}
                </button>{" "}
                <span>
                  {t("surveys.page")}
                   {page} {t("surveys.to")} {totalPages}
                </span>
              </div>

              <Modal
        className="p-5"
        isOpen={isModalOpen}
        toggle={toggleModal}
        title={String(t("Confirm Deletion") || "Confirm Deletion")}
        aria-labelledby="delete-modal-title"
        aria-describedby="delete-modal-description"
      >
        <p id="delete-modal-description" className="m-3">
          {t("surveys.Are you sure you want to delete this survey? This action cannot be undone.")}
        </p>
        <div className="d-flex justify-content-end gap-2 p-3">
          <button className="btn btn-cancle" onClick={toggleModal} aria-label={t("Cancel") || "Cancel"}>
            {t("surveys.Cancel") || "Cancel"}
          </button>
          <button className="btn btn-danger" onClick={handleDelete} aria-label={t("Delete") || "Delete"}>
            <i className="bi bi-trash-fill me-2"></i>
            {t("surveys.Delete") || "Delete"}
          </button>
        </div>
      </Modal>
    </div>
    
  );
};

export default SurvyQuestionTable;